import Vue from 'vue';
import VueRouter from 'vue-router';
//导入路由配置
import routeConfig from 'src/config/router-config.js'
// 导入vuex数据
import store from "src/store/index.js"
// 导入函数库
import control from "src/control/common.js"

Vue.use(VueRouter); //安装vue-router
const router = new VueRouter({  //注册vue-router实例
    mode : 'history',
    routes : routeConfig,
    history: false,
    hashbang: true
});

export default router;

router.beforeEach((to, from, next) => {
    // let id = store.state.userInfo && store.state.userInfo.id; 
    if(to.name == 'login' || to.name == 'wait' || to.name == 'demo'){
        next();
        return;
    }

    // 正常页面
    let code;  //访问页面所需权限
    control.getUserInfo(info=>{   //用户数据是访问所有页面的基础
        if(!info.id){ //没有登录信息
            next({name:'login'});
            return;
        }

        if(to.matched.some(record => record.meta.code && (code = record.meta.code) ) ){   //有权限限制
            console.log(`权限:${code}`);
            // console.log(store.getters.codeList);
            if(store.getters.codeList.some(val=> val==code)){
                next();
            }else{
                next({name:'noPermission'});  //权限不足
            }
        }else{
            next();
        }
    });

});


//  router.beforeEach((to, from, next) => {
//     let time = Number(sessionStorage.loginTime? sessionStorage.loginTime:0);
//     let now = new Date().getTime();
//     let duration = now - time;
//     sessionStorage.loginTime=new Date().getTime();
//     if (!from.name) {
//       if (to.name !== 'login') {
//               if (duration/1000>3000) {return next({name:'login'});}
//               else{next();}
//          }else {
//              next();
//          }
//      }else {
//          if(duration/1000>3000 && from.name !== 'login'){
//              alert('用户登录信息过期，请重新登录')
//              return next({name:'login'});
//          }else {
//              next();
//          }
//      }
//  })
// router.beforeEach((to, from, next) => {
 
     // let time = Number(sessionStorage.loginTime? sessionStorage.loginTime:0);
     // let now = new Date().getTime();
     // let duration = now - time;
     // sessionStorage.loginTime=new Date().getTime();
 
     // if (!from.name) {
     //     if (to.name !== 'login') {
     //         return next({path: ''});
     //     }else {
     //         next();
     //     }
 
     // }else {
     //     if(duration/1000>30000 && from.name !== 'login'){
     //         alert('用户登录信息过期，请重新登录')
     //         return next({name:'login'});
     //     }else {
     //         next();
     //     }
     // }
 
//  })



// WEBPACK FOOTER //
// ./src/control/main-router.js